import React from 'react'
import AtdList from './AtdList';

export default function AtdHome({ data }) {
    const loginbtn = () => {
        const redirect = window.location;
        window.location = process.env.REACT_APP_ACCOUNT_APP_URL + "/signup?redirect=" + redirect
    }
    if (!data) return (<>
        <div className="px-4 md:px-8 py-2">
            <div className=" mt-4 h-10 rounded-lg bg-slate-50 flex justify-between items-center relative overflow-hidden">
                <div className="skeleton">
                </div>
            </div>
            <div className=" mt-4 h-48 rounded-lg bg-slate-50 flex justify-between items-center relative overflow-hidden">
                <div className="skeleton">
                </div>
            </div>
        </div>
    </>)
    return (
        <div className=''>
            {data.success ? (<>
                <AtdList data={data} />
            </>) : (<>
                <div className="bg-orange-200 m-4 p-6 rounded-lg shadow">
                    <div className="md:flex">
                        <div className="md:w-1/2">
                            <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-2 leading-tight">
                                Log in to Access the Attendance Dashboard
                            </h2>

                            <p className="text-gray-700 mb-4">
                                To create and manage your attendance dashboard, please log in to your account. This will enable you to track and manage your team's attendance with ease.
                            </p>

                            <button onClick={loginbtn} className="shadow inline-flex items-center bg-blue-500 hover:bg-blue-600 focus:outline-none focus:shadow-outline text-white font-semibold py-2 px-4 rounded-lg">
                                Log In
                                <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 text-gray-300" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
                                    <circle cx="12" cy="12" r="9" />
                                    <line x1="16" y1="12" x2="8" y2="12" />
                                    <line x1="16" y1="12" x2="12" y2="16" />
                                    <line x1="16" y1="12" x2="12" y2="8" />
                                </svg>
                            </button>
                        </div>
                        <div className="md:w-1/2">
                            <img alt="" className='class="w-64 h-48 object-cover mx-auto mt-2' src='./svg/err/login.svg' />
                        </div>
                    </div>
                </div>
            </>)}


        </div>
    )
}
